import LegalStubPage from "./LegalStubPage";

export default function TermsPage() {
  return <LegalStubPage title="Terms & Conditions" />;
}
